import axios from "axios";

export {
  createServerSideBasket,
  makeOfferBasketIntoDeliveredIn,
  updateSelectedBrandInBasket,
  addAllItemsToApiBasket,
  updateBasketFields,
  getBasket,
};

async function getBasket(basketId) {
  try {
    const basketResponse = await axios.get("/api/getBasket", {
      params: {
        basketId,
      },
    });
    return basketResponse.data.basket;
  } catch (error) {
    return null;
  }
}

async function createServerSideBasket(marketWindowId, items, buyerAccountId) {
  const payload = {
    marketWindowId: marketWindowId,
    items: items.map(({ _id, pricingAuditTrail }) => {
      return { offerId: _id, pricingAuditTrail };
    }),
    buyerAccountId,
  };
  const response = await axios
    .post("/api/createBasket", payload)
    .catch((error) => console.log("Error creating basket: ", error));
  return response.data;
}

async function updateSelectedBrandInBasket(basket, sellerAccountId) {
  const { id, brand } = basket;
  if (!brand || brand === -1) return; // This basket does not require any brand selection
  const payload = {
    basketId: id,
    brand: {
      accountId: sellerAccountId,
      brandId: brand._id,
    },
  };
  const response = await axios.put(`/api/basket/${id}`, payload);
  return response.data;
}

async function addAllItemsToApiBasket(offers, basketId, orderLiftingPeriod = null) {
  try {
    const basketItems = offers.map(
      ({
        _id,
        quantity,
        reference,
        adjustment,
        price,
        fuel_id,
        terminal_id,
        fuel_measurement_id,
        collectionTime,
        networkId,
        pricingAuditTrail,
        liftingPeriod,
        contract,
        updated,
        pricingRulesLastCreated,
        pricingRulesLastUpdated,
        relationshipLastUpdated,
        settlementsLastCreated,
      }) => ({
        offerId: _id,
        quantity,
        offerReference: reference,
        adjustment,
        productId: fuel_id,
        terminalId: terminal_id,
        fuelMeasurementId: fuel_measurement_id,
        collectionTime,
        networkId,
        pricingAuditTrail,
        price,
        liftingPeriod: orderLiftingPeriod && orderLiftingPeriod.length > 0 ? orderLiftingPeriod : liftingPeriod,
        contract,
        updated,
        pricingRulesLastCreated,
        pricingRulesLastUpdated,
        relationshipLastUpdated,
        settlementsLastCreated,
      })
    );

    const payload = {
      basketId,
      offers: basketItems,
    };
    const response = await axios.put("/api/replaceBasketItems", payload);
    return response.data;
  } catch (ex) {
    console.log(ex);
  }
}

async function makeOfferBasketIntoDeliveredIn(basketId, offer) {
  const haulagePayload = {
    haulageId: offer.haulage_id,
    locationId: offer.location_id,
    ...offer.deliveryDate ? {deliveryDate: offer.deliveryDate} : {},
    haulageRate: offer.haulageRate,
  };
  const response = await axios.put(`/api/basket/${basketId}`, haulagePayload);
  return response.data;
}

async function updateBasketFields(basketId, fields = { customLiftingPeriod: null, orderReference: null }) {
  const response = await axios.put(`/api/basket/${basketId}`, { basketId, ...fields });
  return response.data;
}
